import { render } from "./HintBanner.vue?vue&type=template&id=5f4cd91e&scoped=true&ts=true"
import script from "./HintBanner.vue?vue&type=script&lang=ts"
export * from "./HintBanner.vue?vue&type=script&lang=ts"

import "./HintBanner.vue?vue&type=style&index=0&id=5f4cd91e&scoped=true&lang=css"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4cd91e"]])

export default __exports__